import React from 'react';

import { styled } from '../theme';

const Container = styled('div')(({ theme }) => ({
    zIndex: theme.zIndex.pageHeader,
    position: 'absolute',
    top: 100,
    left: 0,
    width: '100%',
    paddingLeft: 30,
    paddingRight: 30,
    background: theme.color.white,
}));

export default ({ children, ...restProps }) => (
    <Container id="page-tabs-menu">{children}</Container>
);
